/**
* author: duxin
* date: 2020/4/7
* describe:
*/

<template>
    <div class="team-chunk">
        <p class="p1">{{$t("about.team")}}</p>
        <div class="content-wrap">
            <div class="desc-wrap" v-for="item in leaderList">
                <el-popover
                        placement="bottom"
                        :title="item.leaderName"
                        width="300"
                        trigger="hover"
                      >
                        <div v-html="item.introduction"  class="ql-snow ql-editor"></div>
                    <img slot="reference" :src="item.icon">
                </el-popover>
                <p>{{item.leaderName}}</p>
                <p class="desc"><span>{{item.department ?item.department: ''}}</span><span>{{item.position}}</span></p>
            </div>
        </div>
    </div>
</template>

<script>
    import {GetLeaderList} from '../../../api/web'

    export default {
        name: "team-chunk",
        data() {
            return {
                leaderList: []
            }
        },
        methods: {
            init() {
                let _params = {
                    companyId: 1,
                    pageNum: 1,
                    pageSize: 100
                };
                GetLeaderList(_params).then(res => {
                    if (res.status) {
                        this.leaderList = res.data.dataList;
                    }
                })
            }
        },
        mounted() {
            this.init()
        }
    }
</script>

<style lang="less" scoped>
    @import "../../../style/constant";

    .team-chunk {
        margin: 100px auto;
        margin-bottom: 0px;
        width: @page-width;

        .p1 {
            font-size: 32px;
            text-align: center;
            font-weight: 500;
        }
        @media screen and (min-width: 320px) and (max-width: 480px){

            .p1 {
                font-size: 24px;
            }
        }

        .content-wrap {
            margin: 80px 0 0 0;
            display: flex;
            flex-wrap: wrap;

            .desc-wrap {
                width: 300px;
                height: 300px;
                overflow: hidden;
                text-align: center;

                img {
                    width: 160px;
                    height: 160px;
                    border-radius: 50%;
                    cursor: pointer;
                    object-fit: cover;
                }

                .desc {
                    color: #435ba1;
                    padding: 10px 30px;
                }
            }

            @media screen and (min-width: 320px) and (max-width: 480px) {
                .desc-wrap {
                    width: 50%;
                    height: 260px;

                    .desc {
                        padding: 0;
                    }
                }
            }
        }
    }

    @media screen and (min-width: 320px) and (max-width: 480px) {
        .team-chunk {
            width: 90%;
        }
    }

</style>
<style lang="less">
.el-popover__title {
  padding: 15px 0 0 15px;
}
</style>